var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenu"}},[_c('Menu',{staticClass:"menuTopClient",attrs:{"id":"menuTop"}}),_c('div',{attrs:{"id":"centre"}},[_c(_vm.layout,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }